(() => {
  if (window.__paragonInseamSwitcher) return;
  window.__paragonInseamSwitcher = true;

  const pendingSections = new WeakSet();

  const getSelectedSize = (section) => {
    for (const input of section.querySelectorAll('variant-picker input[type="radio"]:checked')) {
      const legend = input.closest('fieldset')?.querySelector('legend')?.textContent?.trim().toLowerCase() || '';
      const name = input.name.toLowerCase();
      if (legend.startsWith('size') || name.startsWith('size-')) return input.value;
    }

    for (const select of section.querySelectorAll('variant-picker select')) {
      const label = Array.from(select.labels || []).map((item) => item.textContent).join(' ').trim().toLowerCase();
      if (label.startsWith('size') || select.name.toLowerCase().includes('[size]')) return select.value;
    }

    return '';
  };

  const getVariantIdForSize = async (productUrl, selectedSize) => {
    const jsonUrl = new URL(productUrl);
    jsonUrl.pathname = `${jsonUrl.pathname.replace(/\/$/, '')}.js`;
    jsonUrl.search = '';
    const response = await fetch(jsonUrl, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Product request failed: ${response.status}`);

    const product = await response.json();
    const sizeIndex = (product.options || []).findIndex((option) => {
      const name = typeof option === 'string' ? option : option?.name;
      return String(name || '').trim().toLowerCase().startsWith('size');
    });
    const variant = (product.variants || []).find((candidate) => candidate.options?.[sizeIndex] === selectedSize);
    return variant?.id ? String(variant.id) : '';
  };

  window.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const link = target?.closest('inseam-switcher a');
    const switcher = link?.closest('inseam-switcher');
    const currentSection = switcher?.closest('featured-product-information, .featured-product-section');
    if (!link || !currentSection) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (link.hasAttribute('aria-current') || pendingSections.has(currentSection)) return;

    const sectionId = switcher.dataset.sectionId || currentSection.id;
    if (!sectionId) return;

    pendingSections.add(currentSection);
    switcher.setAttribute('aria-busy', 'true');
    switcher.querySelector('[data-switch-error]')?.remove();

    try {
      const productUrl = new URL(link.href, window.location.origin);
      const selectedSize = getSelectedSize(currentSection);
      if (selectedSize) {
        const variantId = await getVariantIdForSize(productUrl, selectedSize);
        if (variantId) productUrl.searchParams.set('variant', variantId);
      }

      const sectionUrl = new URL(productUrl);
      sectionUrl.searchParams.set('section_id', sectionId);
      const response = await fetch(sectionUrl, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Section request failed: ${response.status}`);

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextSection = currentSection.matches('featured-product-information')
        ? html.getElementById(sectionId)
        : html.querySelector('.featured-product-section');
      if (!nextSection || !nextSection.matches('featured-product-information, .featured-product-section')) {
        throw new Error('Featured product section not found');
      }
      if (!currentSection.isConnected) return;

      const nextLink = Array.from(nextSection.querySelectorAll('inseam-switcher a')).find((option) =>
        new URL(option.href, window.location.origin).pathname === productUrl.pathname
      );
      const restoreFocus = switcher.contains(document.activeElement);
      currentSection.replaceWith(nextSection);
      if (restoreFocus) nextLink?.focus({ preventScroll: true });
    } catch (error) {
      console.warn('[inseam-switcher] in-place switch failed', error);
      if (switcher.isConnected) {
        const message = document.createElement('p');
        message.dataset.switchError = '';
        message.setAttribute('role', 'alert');
        message.textContent = 'Unable to change inseam. Please try again.';
        switcher.appendChild(message);
      }
    } finally {
      pendingSections.delete(currentSection);
      switcher.removeAttribute('aria-busy');
    }
  }, true);
})();
